import React from 'react'
import { i18n } from '@/locale/i18n'
import './LoginError.scss'

const LoginError = React.memo(({ error }) => {
  if (error == null) {
    return null
  }

  let message = ''

  
  // This 400 shouldn't be here. Ask backend to change to 401 when password doesn't match
  if (error.status === 400 || error.status === 401) {
    message = i18n('login.wrong_password')

    if(error.error === 'invalid_2fa_token') message = i18n('login.invalid_2fa_token') 
  }

  if (error.status === 500) {
    message = i18n('login.server_failure')
  }

  return (
    <div className="login-error__message" data-test="login-error-message">
      {message}
    </div>
  )
})

export default LoginError
